
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class caseItem extends Vue {
  @Prop({ required: true }) private item!: any;
  @Prop({}) private isSelect!: any;
  formatUpyunUrl = formatUpyunUrl;
}
